var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconOfficialC = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#icon_official_c_svg__a)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 7,
  cy: 7,
  r: 7,
  fill: "#A343F3"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M3.994 6.854c0-1.898 1.339-3.289 3.25-3.289 1.222 0 1.963.52 2.405 1.118l-.897.832q-.527-.741-1.443-.741c-1.144 0-1.898.858-1.898 2.08s.754 2.093 1.898 2.093c.611 0 1.092-.26 1.443-.741l.897.832c-.442.598-1.183 1.118-2.405 1.118-1.911 0-3.25-1.391-3.25-3.302"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "icon_official_c_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h14v14H0z"
})))));
export default SvgIconOfficialC;